export const TAGS_FRAGMENT = `{
  text
  type
}`
